"use strict";

import angular from "angular";

import DiasConfirm from "dias/core/confirm";
import DiasNotification from "dias/core/notification";

import services from "dias/workflow/services";
import functionCls from "./function";

const modul = angular.module("standard_workflowmodule.download_after_confirm", [
  DiasConfirm.name,
  DiasNotification.name,
  services.name
])

  .config(/*@ngInject*/WorkflowfunktionRegistryProvider => {
    WorkflowfunktionRegistryProvider.register("download_after_confirm", functionCls);
  });


export default modul;
